
import { useState } from "react";

const contacts = [
    { id: "tanisha", name: "Tanisha Jain", phone: "+1 662 380 4214" },
    { id: "tanmay", name: "Tanmay Jain", phone: "+1 984 777 1847" },
    { id: "ruhaan", name: "Ruhaan Jain", phone: "+1 630 898 6689" },
    { id: "nehaa", name: "CA. Nehaa Samyak Luniya", phone: "+91 83194 36955" },
    { id: "sheetal", name: "Sheetal Jain Raipur", phone: "+91 98261 36901" },
];

function PhoneIcon() {
    return (
        <svg width="1.3rem" height="1.3rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 21.73 16z" />
        </svg>
    );
}

function MailIcon() {
    return (
        <svg width="1.3rem" height="1.3rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
        </svg>
    );
}

function EyeIcon() {
    return (
        <svg width="1.4rem" height="1.4rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    );
}

function EyeOffIcon() {
    return (
        <svg width="1.4rem" height="1.4rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
            <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
            <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
    );
}

function InstagramIcon() {
    return (
        <svg width="1.25rem" height="1.25rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="2" width="20" height="20" rx="5" />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
        </svg>
    );
}

function FacebookIcon() {
    return (
        <svg width="1.25rem" height="1.25rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
        </svg>
    );
}

function YouTubeIcon() {
    return (
        <svg width="1.25rem" height="1.5rem" viewBox="0 0 24 24" fill="none" stroke="var(--Background-light-Color)"
            strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.96C18.88 4 12 4 12 4s-6.88 0-8.6.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.94 1.96C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z" />
            <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" />
        </svg>
    );
}

function ContactRow({ contact }) {
    const [revealed, setRevealed] = useState(false);

    return (
        <div className="cd-item">
            <div className="cd-icon-wrapper">
                <PhoneIcon />
            </div>
            <div className="cd-contact-info">
                <div className="cd-name-row">
                    <span className="cd-name">{contact.name}</span>
                </div>
                <div className="cd-phone-row">
                    <span className="cd-dash">–</span>
                    {revealed ? (
                        <span className="cd-phone-num">{contact.phone}</span>
                    ) : (
                        <span className="cd-dots">●●●● ●●● ●●●●</span>
                    )}
                    <button
                        className="cd-eye-btn"
                        onClick={() => setRevealed(!revealed)}
                        title={revealed ? "Hide number" : "Show number"}
                    >
                        {revealed ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                </div>
            </div>
        </div>
    );
}

function SocialIcon({ href, children, title }) {
    return (
        <a
            href={href}
            title={title}
            target="_blank"
            rel="noopener noreferrer"
            className="cd-soc"
        >
            {children}
        </a>
    );
}

export default function ContactusDetails() {
    return (
       <div className="customcontainer">
         <div className="cd-customcontainer" data-aos="fade-up">
            <div className="cd-page-wrap">
                <div className="cd-wrapper">
                    {/* LEFT – image */}
                    {/* <div className="cd-left-panel">
                        <img src={PLACEHOLDER} alt="Contact" className="cd-contact-img" />
                    </div> */}

                    {/* RIGHT – contact info */}
                    <div className="cd-right-panel">
                        <h2 className="cd-heading">
                           Get in Touch
                        </h2>

                        <div className="cd-group">
                            <div className="cd-items">
                                {/* Email */}
                                <div className="cd-item">
                                    <div className="cd-icon-wrapper">
                                        <MailIcon />
                                    </div>
                                    <div className="cd-contact-info">
                                        <div className="cd-email-row">
                                            <a href="mailto:veersamyak51@gmail.com" className="cd-email-link">
                                                veersamyak51@gmail.com
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                {/* Phone contacts */}
                                {contacts.map((c) => (
                                    <ContactRow key={c.id} contact={c} />
                                ))}
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="cd-footer">
                            <div className="cd-social-row">
                                <span className="cd-social-label">Connect With Us</span>
                                <SocialIcon href="#" title="Instagram">
                                    <InstagramIcon />
                                </SocialIcon>
                                <SocialIcon href="#" title="Facebook">
                                    <FacebookIcon />
                                </SocialIcon>
                                <SocialIcon href="#" title="YouTube">
                                    <YouTubeIcon />
                                </SocialIcon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                /* Base Styles */
                .cd-customcontainer {
                    margin: 0 auto;
                    // padding: 0 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .cd-page-wrap {
                    background: #fff;
                    display: flex;
                    align-items: center;
                   
                    justify-content: center;
                 
                }

                .cd-wrapper {
                    display: grid;
                    width: 100%;
                     width: 650px;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 8px 60px rgba(0,0,0,0.10);
                    background: #ffffff;
                    border: 1px solid var(--Background-Dark-Color);
                    border-radius: 1rem;
                }

                .cd-left-panel {
                    position: relative;
                    min-height: 480px;
                    background: #e8e8e8;
                    overflow: hidden;
                }

                .cd-contact-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    display: block;
                }

                .cd-right-panel {
                    padding: 4rem;
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    background: #ffffff;
                }

                .cd-heading {
                    font-size: 32px;
                    font-weight: 600;
                    color: #98602e;
                    line-height: 1.2;
                    margin: 0;
                    text-align: center;
                    font-family: var(--Heading-Font);
                }

                .cd-group {
                    border-top: 1px solid #e0ddd8;
                    padding-top: 16px;
                }

                .cd-items {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    // align-items: center;
                }

                .cd-item {
                    display: flex;
                    align-items: flex-start;
                    gap: 15px;
                    // justify-content: center;
                    color: #1a1a1a;
                }

                .cd-icon-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 24px;
                    flex-shrink: 0;
                    padding-top: 2px;
                }

                .cd-contact-info {
                    display: flex;
                    flex-direction: column;
                    flex: 1;
                }

                .cd-email-row {
                    display: flex;
                    align-items: center;
                }

                .cd-email-link {
                    color: #1a1a1a;
                    text-decoration: none;
                    font-size: 16px;
                    word-break: break-all;
                    line-height: 1.5;
                }

                .cd-name-row {
                    display: flex;
                    align-items: center;
                }

                .cd-name {
                    font-size: 16px;
                    color: #1a1a1a;
                    line-height: 1.5;
                }

                .cd-phone-row {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 6px;
                }

                .cd-dash {
                    color: #6b6b6b;
                    font-size: 16px;
                }

                .cd-dots {
                    color: #6b6b6b;
                    letter-spacing: 2px;
                    font-size: 13px;
                    line-height: 1.5;
                }

                .cd-phone-num {
                    font-size: 16px;
                    color: #1a1a1a;
                    font-variant-numeric: tabular-nums;
                    word-break: break-all;
                    line-height: 1.5;
                }

                .cd-eye-btn {
                    background: none;
                    border: none;
                    cursor: pointer;
                    padding: 0 4px;
                    color: #6b6b6b;
                    display: inline-flex;
                    align-items: center;
                    border-radius: 4px;
                    transition: color 0.15s;
                }

                .cd-eye-btn:hover {
                    color: #1a1a1a;
                }

                .cd-footer {
                    margin-top: auto;
                    padding-top: 16px;
                    border-top: 1px solid #e0ddd8;
                }

                .cd-social-row {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                }

                .cd-social-label {
                    font-size: 16px;
                    color: #6b6b6b;
                    letter-spacing: 0.08em;
                    text-transform: uppercase;
                    font-weight: 500;
                }

                .cd-soc {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    border: 0.5px solid var(--Background-light-Color);
                    color: var(--Background-light-Color);
                    text-decoration: none;
                    transition: all 0.18s;
                    cursor: pointer;
                }

                .cd-soc:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }

                /* Desktop - Sab ek row mein */
                @media (min-width: 769px) {
                    .cd-contact-info {
                        flex-direction: row;
                        align-items: baseline;
                        gap: 6px;
                    }

                    .cd-phone-row {
                        flex: 1;
                    }
                }

                /* Tablet Styles */
                @media (max-width: 980px) {
                .cd-page-wrap{
                width: 100%;
                }
                    .cd-customcontainer {
                        // padding: 0 16px;
                    }

                    .cd-wrapper {
                        grid-template-columns: 1fr;
                    }

                    .cd-left-panel {
                        min-height: 300px;
                    }

                    .cd-right-panel {
                        padding: 32px 28px;
                    }

                    .cd-heading {
                        font-size: 28px;
                    }
                }

                /* Mobile Styles - Name+icon upar, phone+eye neeche */
                @media (max-width: 768px) {
                    .cd-contact-info {
                        flex-direction: column;
                        gap: 4px;
                    }

                    .cd-phone-row {
                        padding-left: 0;
                    }

                    .cd-dash {
                        display: none;
                    }
                }

                @media (max-width: 480px) {
                    .cd-customcontainer {
                        // padding: 0 12px;
                    }

                    .cd-wrapper {
                        border-radius: 12px;
                    }

                    .cd-left-panel {
                        min-height: 220px;
                    }

                    .cd-right-panel {
                        padding: 24px 16px;
                        gap: 20px;
                    }

                    .cd-heading {
                        font-size: 24px;
                    }

                    .cd-item {
                        gap: 10px;
                    }

                    .cd-email-link,
                    .cd-name,
                    .cd-phone-num {
                        font-size: 14px;
                    }

                    .cd-dots {
                        font-size: 12px;
                    }

                    .cd-social-row {
                        flex-wrap: wrap;
                        justify-content: center;
                    }

                    .cd-social-label {
                        width: 100%;
                        text-align: center;
                        margin-bottom: 8px;
                        font-size: 14px;
                    }

                    .cd-soc {
                        width: 36px;
                        height: 36px;
                    }
                }
            `}</style>
        </div>
       </div>
    );
}